import CategoryCharityContextProvider from "../../../context/category-charity/provider";
import PageDetails from "../../general/details";
import {useTranslation} from "react-i18next";
import {useNavigate, useParams} from "react-router-dom";
import {useContext, useEffect} from "react";
import CategoryCharityContext from "../../../context/category-charity/context";
import AppContext from "../../../context/app/context";
import Spin from "../../general/antd/spin";
import Descriptions from "../../general/antd/descriptions";
import {Descriptions as AntdDescriptions} from "antd";
import OldImage from "../../form-components/old-image";

interface Props {
}

const CategoryCharity: React.FC<Props> = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const {id} = useParams();
    const {details, actions, loading} = useContext(CategoryCharityContext);
    const {direction} = useContext(AppContext);

    useEffect(() => {
        const getDetails = async () => {
            id && (await actions.getDetails(Number(id)));
        };
        getDetails();
    }, [direction]);

    return (
        <PageDetails
            title={t("details")}
            subtitle={t("charities_manager")}
            buttonName={`${t("update_category_charities")}`}
            onClick={() => navigate(`/categories_charities/update/${id}`)}
        >
            {loading.includes("details") ? (
                <Spin/>
            ) : (
                <Descriptions size="small" column={1} bordered>
                    <AntdDescriptions.Item label={t("id")}>
                        {details?.id}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("note")}>
                        {details?.note ?? "-"}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("priority")}>
                        {details?.priority ?? "-"}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("image")}>
                        {details?.image ? (
                            <OldImage preview src={details?.image?.url} />
                        ) : (
                            "-"
                        )}
                    </AntdDescriptions.Item>
                </Descriptions>
            )}
        </PageDetails>
    )
}

const CategoryCharityDetailsPage = () => {
    return (
        <CategoryCharityContextProvider>
            <CategoryCharity/>
        </CategoryCharityContextProvider>
    );
};
export default CategoryCharityDetailsPage;